export let menuList = [
  {
    Id: 201,
    name: '文献库',
    url: '/historyArea',
    isLogin: true,
    showText:
      '改革开放重要领域政策法规、理论研究、大事记、回忆文章和统计数据等历史资料数据库'
  },
  {
    Id: 202,
    name: '事件库',
    url: '/historyEvent/' + '0',
    isLogin: true,
    showText: '对改革有着重大影响的事件专题数据库'
  },
  {
    Id: 203,
    name: '人物库',
    url: '/historyPerson/' + '0',
    isLogin: true,
    showText: '对改革有着重大影响的人物专题数据库'
  },
  {
    Id: 204,
    name: '机构库',
    url: '/historyMechanism/' + '0',
    isLogin: true,
    showText: '专门推进改革决策、实施和研究的机构专题数据库'
  },
  {
    Id: 205,
    name: '地区库',
    url: '/historyRegion/' + '0',
    isLogin: true,
    showText: '全国各省、市、自治区改革开放历史资料专题数据库'
  },
  {
    Id: 206,
    name: '口述库',
    url: '/historyAccount/' + '0',
    isLogin: true,
    showText: '中改院口述改革历史人物访谈项目专题数据库'
  },
  {
    Id: 207,
    name: '实物库',
    url: '/historyObject/' + '0',
    isLogin: true,
    showText: '改革历史见证物资料信息专题数据库'
  },
  {
    Id: 208,
    name: '中改院',
    url: '/historyCird/' + '0',
    isLogin: true,
    showText: '中国（海南）改革发展研究院的改革理论探索资料专题数据库'
  }
]



// WEBPACK FOOTER //
// ./src/modules/common/header/menuListData.js